import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "itemId", "playlistId", "itemType", "language", "onSuccess", "showNotification", "onClick", "use"];
import getLang from 'LearningCenterUI/utils/getLang';
import Raven from 'raven-js';
import { Button } from 'foundations-components/transitional/components/Button';
import { useRemoveFromPlaylist } from '../../savedItems/savedItemsQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const RemoveItemFromPlaylistButton = _ref => {
  let {
      children,
      itemId,
      playlistId,
      itemType,
      language = getLang(),
      onSuccess,
      showNotification = true,
      onClick,
      use = 'unstyled'
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [removeFromPlaylist, {
    removeFromPlaylistMutationLoading
  }] = useRemoveFromPlaylist({
    showNotification
  });
  const handleOnClick = e => {
    if (removeFromPlaylistMutationLoading) return;
    if (onClick) onClick(e);
    removeFromPlaylist({
      playlistId,
      itemId,
      language,
      type: itemType
    }).then(onSuccess).catch(() => {
      Raven.captureMessage(`Achievements: error removing item from playlist`, {
        extra: {
          playlistId,
          itemId,
          language,
          itemType
        }
      });
    });
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
    onClick: handleOnClick,
    use: use,
    children: children
  }));
};
export default RemoveItemFromPlaylistButton;